import React, { useEffect } from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { createPortal } from 'react-dom';
import { US_STATES, type LoanOfficer } from '../data/leadDistribution';
import { RiverCityBrand } from './RiverCityBrand';
interface StateLicensesModalProps {
  officer: LoanOfficer;
  onClose: () => void;
}
export function StateLicensesModal({
  officer,
  onClose
}: StateLicensesModalProps) {
  const licensed = new Set(officer.licensedStates);
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);
  return createPortal(<div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/55 p-4" onClick={onClose} role="presentation" data-id="element-125" data-mp="4ogm6gkhegh4">
      <div role="dialog" aria-modal="true" aria-labelledby="licenses-modal-title" onClick={event => event.stopPropagation()} className="relative w-full max-w-lg overflow-hidden rounded-lg bg-white shadow-2xl" data-id="element-126" data-mp="pg4j1dqpjvp">
        <div className="h-1 bg-rcm-500" data-id="element-127" data-mp="1yswlt0k5xmz1" />
        <button type="button" onClick={onClose} aria-label="Close" className="absolute right-4 top-5 flex h-8 w-8 items-center justify-center rounded-full bg-slate-100 text-slate-500 transition-colors hover:bg-rcm-50 hover:text-rcm-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-rcm-500" data-id="element-128" data-mp="23tkc1k0khzs7">
          <XIcon className="h-4 w-4" data-id="element-129" data-mp="2hkpc2n7uku32" />
        </button>

        <div className="border-b border-slate-200 px-6 py-5 pr-14" data-id="element-130" data-mp="2hnbj8lqtt7kr">
          <RiverCityBrand compact data-id="element-131" data-mp="2ml3bjgvduvph" />
          <h2 id="licenses-modal-title" className="mt-5 text-lg font-bold text-slate-800" data-id="element-132" data-mp="2rjmxvidw29id">{officer.name} — State Licenses</h2>
          <p className="mt-1 text-xs font-medium text-slate-400" data-id="element-133" data-mp="s72aqqg9vymr">NMLS #{officer.nmls}</p>
        </div>

        <div className="max-h-[70vh] overflow-y-auto px-6 py-5" data-id="element-134" data-mp="x4u3tnsnlqsj">
          <p className="mb-4 text-sm text-slate-500" data-id="element-135" data-mp="x7gjkapp7clu">Active licenses are marked in RiverCity blue.</p>
          <div className="grid grid-cols-2 gap-2 sm:grid-cols-4" data-id="element-136" data-mp="l3cb6n7aey1f">
            {US_STATES.map(state => {
            const isLicensed = licensed.has(state);
            return <div key={state} className={`flex items-center justify-between rounded-md border px-3 py-2 text-sm ${isLicensed ? 'border-rcm-200 bg-rcm-50 font-bold text-rcm-800' : 'border-slate-200 bg-white text-slate-500'}`} data-id="element-137" data-mp="z10ys2sqoja6">
                  <span data-id="element-138" data-mp="142q9fhc1uuxq">{state}</span>
                  {isLicensed && <span className="flex h-4 w-4 items-center justify-center rounded bg-rcm-500 text-white" data-id="element-139" data-mp="141ye87md6z7z"><CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-140" data-mp="1ht3hdjoxy9n2" /></span>}
                </div>;
          })}
          </div>
        </div>
      </div>
    </div>, document.body);
}